import { observer } from "mobx-react"

import { AgentInstances } from "src/components/AgentSelection"
import { KnowledgeItemStore } from "src/modals/knowledge-items/store"
import { useStore } from "src/store/lib/useStore"

export const KnowledgeItemsAgentInstances = observer(() => {
    const store = useStore(KnowledgeItemStore)

    return <AgentInstances store={store} />
})
